import { MessageCircle, Check, Clock, Trash2 } from "lucide-react";
import { blogPosts } from "@/data/blogPosts";
import { fmtWhen } from "./adminUtils";

const titleForSlug = (slug) => blogPosts.find((p) => p.slug === slug)?.title || slug;

function CommentCard({ c, onApprove, onDelete }) {
  return (
    <div
      className={`rounded-2xl p-5 border shadow-sm ${c.approved ? "bg-white border-slate-100" : "bg-[#FFFBEB] border-[#FCD34D]"}`}
      data-testid="admin-comment-card"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="font-semibold text-[#0F172A] leading-none">{c.name}</p>
          <p className="mt-1 text-xs text-[#94A3B8]">{titleForSlug(c.slug)} · {fmtWhen(c.created_at)}</p>
        </div>
        <span className={`shrink-0 inline-flex items-center gap-1 text-[11px] font-bold rounded-full px-2.5 py-1 ${c.approved ? "bg-[#10B981]/12 text-[#0E9F6E]" : "bg-[#F59E0B]/15 text-[#B45309]"}`}>
          {c.approved ? <><Check size={11} /> Live</> : <><Clock size={11} /> Pending</>}
        </span>
      </div>
      <p className="mt-3 text-[#334155] leading-relaxed whitespace-pre-line">{c.text}</p>
      <div className="mt-4 flex items-center gap-2">
        {!c.approved && (
          <button
            onClick={() => onApprove(c.id)}
            className="inline-flex items-center gap-1.5 bg-[#10B981] text-white text-sm font-semibold px-4 py-2 rounded-full hover:-translate-y-0.5 transition-all"
            data-testid={`approve-comment-${c.id}`}
          >
            <Check size={15} /> Approve
          </button>
        )}
        <button
          onClick={() => onDelete(c.id)}
          className="inline-flex items-center gap-1.5 bg-white text-[#DC2626] border border-[#FCA5A5] text-sm font-semibold px-4 py-2 rounded-full hover:bg-[#FEF2F2] transition-all"
          data-testid={`delete-comment-${c.id}`}
        >
          <Trash2 size={15} /> Delete
        </button>
      </div>
    </div>
  );
}

export function CommentsPanel({ comments, onApprove, onDelete }) {
  if (!comments.length) return null;
  const pendingCount = comments.filter((c) => !c.approved).length;
  return (
    <div className="mb-10" data-testid="admin-comments">
      <div className="flex items-center gap-2 mb-4">
        <MessageCircle size={18} className="text-[#0EA5E9]" />
        <h2 className="font-heading text-lg font-semibold text-[#0F172A]">Blog comments</h2>
        {pendingCount > 0 && (
          <span className="text-xs font-bold text-white bg-[#F59E0B] rounded-full px-2.5 py-0.5" data-testid="pending-count">
            {pendingCount} awaiting review
          </span>
        )}
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {comments.map((c) => <CommentCard key={c.id} c={c} onApprove={onApprove} onDelete={onDelete} />)}
      </div>
    </div>
  );
}
